export default __webpack_public_path__ + "static/media/slide2.298c1b5e.jpg";